"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sanitizeJSON;
function sanitizeJSON(json) {
  return json.replace(/\u2028/g, '');
}